import { render, staticRenderFns } from "./ConsentFormOk.vue?vue&type=template&id=21b46a86&"
import script from "./ConsentFormOk.vue?vue&type=script&lang=js&"
export * from "./ConsentFormOk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports